/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//import moment from 'moment';
import moment from "moment-timezone";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { VApplication } from "../../../application";
import { GET_SCHEDULES } from "../graphql/getSchedules.query";
const is = require("is_js");

// const MODULE_NAME = 'CostumeService.getDataContent';
// const log:any = LoggerModule?.getInstance()?.getLogger()?.extend(MODULE_NAME);
// LoggerModule?.getInstance()?.getLogger()?.enable(MODULE_NAME);

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};
export interface IGetSchedulesMethods extends IPluginMethodMap {
  getSchedules(args: any): Promise<any>;
}
export class GetSchedulesService implements IAgentPlugin {
  readonly methods: IGetSchedulesMethods;
  constructor() {
    this.methods = {
      getSchedules: this.getContent.bind(this),
    };
  }
  async getContent(args: any) {
    console.log("getSchedules args", args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    let res: any = null;
    try {
      if (client) {
        res = await client.query({
          query: GET_SCHEDULES,
          variables: {
            filters: {
              sections__in: args?.sections__in,
            },
          },
          fetchPolicy: "network-only",
        });
        if (res?.data) {
          return {
            // ...res?.data,
            schedulesDateAndSlotList: this.getFormattedDate(
              res?.data?.getSchedules?.content,
              res?.data?.getSchedules?.getMetadata?.eventTimeZone
            ),
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }
      throw err;
      // log.error(`error in getting `, err);
      // throw new Error('CostumeService getSchedules' + err?.message);
    }
  }
  private getFormattedDate(dateDetails: any, timeZone: any) {
    let createTimeSlot = [];
    let finalSlot: [] = [];
    let timeZ = "America/Port_of_Spain";
    if (is.existy(timeZone?.tmz) && is.not.empty(timeZone?.tmz)) {
      timeZ = timeZone?.tmz;
    }
    for (const slot of dateDetails) {
      var evenStartTime = moment(slot?.eventStartTime);
      let dateInfoObj = slot;
      let formatObj = {
        dateIndex: evenStartTime.tz(timeZ).format("DDMMYYYY"),
        formatedDate: evenStartTime.tz(timeZ).format("DD-MM-YYYY zz"),
        slotTime: evenStartTime.tz(timeZ).format("LT"),
      };
      dateInfoObj = { ...dateInfoObj, ...formatObj };
      createTimeSlot.push(dateInfoObj);
    }
    var tempDates: any = {};
    for (const slot of createTimeSlot) {
      if (is.existy(tempDates[slot.dateIndex])) {
        tempDates[slot.dateIndex].push(slot);
      } else {
        tempDates[slot.dateIndex] = [];
        tempDates[slot.dateIndex].push(slot);
      }
    }
    let dateList = [];
    for (var key of Object.keys(tempDates)) {
      dateList.push({
        id: key,
        date: key,
        formatedDate: tempDates[key][0]?.formatedDate,
        timeZone: timeZ,
        numberOfSlots:
          tempDates[key].length === 1
            ? `${tempDates[key].length}  slot available`
            : `${tempDates[key].length}  slots available`,
        slotsList: tempDates[key],
      });
    }
    console.log("dateList", dateList);
    return dateList;
  }
}
